module.exports = __webpack_public_path__ + "static/media/addtotrip_ic.ce3ce083.svg";